<template>
    <section v-if="json" class="page-generic">
        <div class="generic-top" data-aos="custom-fade-in" >
            <div class="capper">
                <div class="capper-padded-4x">
                    <div class="copy">
                        <h1>{{json.title}}</h1>
                    </div>

                </div>
            </div>
        </div>
        <ContentBlocks :json="json" />
    </section>
</template>
<script>
import axios from 'axios'
import gh from '@/helpers/gh'
import ContentBlocks from "@/components/blocks/ContentBlocks.vue";
export default {
    name: "GenericPagePage",
    components: {
        ContentBlocks,
    },
    data () {
        return {
            window: window,
            json: null,
            transition: false,
        }

    },
    created () {
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        const turl = gh.formatFeedUrl(slug)
        axios.get((turl))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((e) => {
                console.error('Error',slug,e)
        })
    },
    methods: {
        reveal () {

        },
        unreveal () {

        },
    }
}
</script>
